import {Maybe} from 'graphql/jsutils/Maybe';
import isNumber from 'lodash';
import {useRouter} from 'next/router';
import {HTMLAttributes} from 'react';
import {t} from '../../../common/getTranslations';
import {formatWithCommas} from '../../../common/shared/utils/formatWithCommas';
import {twMerge} from '../../../common/twMerge';
import {IconType} from '../../../design-system/atoms/Icon/IconType.enum';
import {BelowDefaultTab} from '../../../design-system/organisms/BelowDefaultTab/BelowDefaultTab';
import {HistoryListType} from '../../../domain/history/type';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';

export interface TodayGiftListToolbarProps
  extends HTMLAttributes<HTMLDivElement> {
  ticketCount?: Maybe<number>;
  currentCategoryName?: string;
  currentSubCategoryName?: string;
  onClickSubCategory: () => void;
}

export function TodayGiftListToolbar({
  ticketCount,
  currentCategoryName,
  currentSubCategoryName,
  onClickSubCategory,
  className,
  ...props
}: TodayGiftListToolbarProps) {
  const router = useRouter();

  return (
    <div
      className={twMerge('flex bg-theme-bg-base px-15pxr py-14pxr', className)}
      {...props}
    >
      <div className="font-small2 flex-1 text-theme-solid-60">
        {t('common_ticket_amount', {
          values: {
            value:
              ticketCount && isNumber(ticketCount)
                ? formatWithCommas(ticketCount)
                : 0,
          },
        })}
      </div>
      <div className="font-small2 flex shrink-0 space-x-16pxr text-theme-solid-100">
        {currentSubCategoryName && (
          <BelowDefaultTab.SelectBox
            onClick={onClickSubCategory}
            iconType={IconType.TabFilter}
          >
            {currentSubCategoryName}
          </BelowDefaultTab.SelectBox>
        )}
        <BelowDefaultTab.SelectBox
          onClick={e => {
            router.push(
              `/history/ticket?tab=${HistoryListType.Buy}&is_free_only=true`
            );
            LOG_CLICK_EVENT('이용권_보러가기_클릭', e);
          }}
          {...putTiaraObjectProps({
            click: {
              layer1: '상단',
              copy: '받은선물 내역',
            },
            customProps: {
              page_category_filter: currentCategoryName,
              page_genre_filter: currentSubCategoryName,
            },
          })}
          iconType={IconType.TabGiftList}
        >
          {t('giftbox_gift_list')}
        </BelowDefaultTab.SelectBox>
      </div>
    </div>
  );
}
